import { toggleCollapsible } from "./registration-flow";

(function init() {
    initCollapsible();
    goToLink();
})();

function goToLink() {
    const navLinks = document.querySelectorAll(".qna__nav-link");
    const hash = window.location.hash || "#all";

    function setActiveLink() {
        navLinks.forEach(link => {
            const linkHash = link.getAttribute("href");
            if (linkHash === hash) {
                link.classList.add("qna__nav-link--active", "active");
            } else {
                link.classList.remove("qna__nav-link--active", "active");
            }
        });
    }

    navLinks.forEach(link => {
        link.addEventListener("click", function() {
            navLinks.forEach(nav =>
                nav.classList.remove("qna__nav-link--active", "active")
            );
            this.classList.add("qna__nav-link--active", "active");
        });
    });

    setActiveLink();

    if (hash) {
        const targetElement = document.querySelector(hash);
        if (targetElement) {
            window.scrollTo({
                behavior: "smooth"
            });
        }
    }
}

function initCollapsible() {
    const container = document.querySelector(".qna__answers");
    if (container) {
        container.addEventListener("click", function(event) {
            // Check if one of the clicked elements is a .qna__heading
            if (
                event.target.matches(".qna__heading") ||
                event.target.closest(".qna__heading")
            ) {
                toggleCollapsible(event);
            }
        });
    }
}
